
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

const RefinanceHeroSection: React.FC = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center text-white overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(220, 38, 38, 0.9) 0%, rgba(0, 0, 0, 0.9) 100%), url('https://public.readdy.ai/ai/img_res/cd29c8767689d51931f822464bdba64f.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-red-600/90 to-black/90"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Explore Your 
            <span className="text-red-400 block">Refinance Options</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed text-gray-200">
            Lower your payments, shorten your term, or access equity. Find out which option is right for you.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button 
                variant="primary" 
                size="large"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                See If You Qualify
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RefinanceHeroSection;